import { FeatureFlagObject, FeatureFlagTypes } from 'flow/types/FeatureFlags';

export const featureFlagCheck = (
    listFeatureFlags: FeatureFlagObject[],
    feature: FeatureFlagTypes,
) => listFeatureFlags.find((f) => f.feature === feature)?.enabled;
